import { useEffect } from 'react';
import { UserInfo } from '@/types/userInfo';
import { http } from '@/utils/http';
import useUserAuth from '@/hooks/useUserAuth';
import { useAppState } from '@/hooks/useAppState';
import { logger } from '@/utils/logger';
import { useSessionStorage } from 'react-use';

export const useUserInfo = () => {
  const { isUserLoggedIn } = useUserAuth();
  const [userInfo, setUserInfo] = useSessionStorage<UserInfo | null>('userInfo', null);
  const [{}, appStateDispatcher] = useAppState();

  useEffect(() => {
    if (!isUserLoggedIn) return;

    if (userInfo) {
      appStateDispatcher({
        userInfo: { ...userInfo },
      });
      return;
    }

    const fetchUserInfo = async () => {
      const response = await http.get<UserInfo>('/api/user/info');
      if (!response?.data) {
        logger.error('No data received from /api/user/info');
        return;
      }

      setUserInfo(response.data);
      appStateDispatcher({
        userInfo: { ...response.data },
      });
    };

    fetchUserInfo();
  }, [isUserLoggedIn]);

  return { userInfo };
};
